import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { shouldEnableSentry } from './lib/sentry-config.ts';

const sentryEnvironment = import.meta.env.VITE_APP_ENV;

if (shouldEnableSentry(sentryEnvironment, window.location.hostname)) {
  Sentry.init({
    dsn: 'https://fcdda03cd8847482512d555041dd0cf5@o4511576844664832.ingest.us.sentry.io/4511576908365824',
    environment: sentryEnvironment,
    dataCollection: {},
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
